import { render, staticRenderFns } from "./InspirationOverview.vue?vue&type=template&id=3a2b8355&scoped=true"
import script from "./InspirationOverview.vue?vue&type=script&lang=ts"
export * from "./InspirationOverview.vue?vue&type=script&lang=ts"
import style0 from "./InspirationOverview.vue?vue&type=style&index=0&id=3a2b8355&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2b8355",
  null
  
)

export default component.exports